export function darkenColor(hex: string, percent: number): string {
    // Convert percentage to 0–1 range
    const factor = 1 - percent / 100;
  
    // Clean up the hex
    hex = hex.replace(/^#/, '');
  
    // Handle short hex
    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }
  
    // Convert to RGB
    const r = Math.round(parseInt(hex.slice(0, 2), 16) * factor);
    const g = Math.round(parseInt(hex.slice(2, 4), 16) * factor);
    const b = Math.round(parseInt(hex.slice(4, 6), 16) * factor);
  
    // Convert back to hex
    const toHex = (v: number) => v.toString(16).padStart(2, '0');
    console.log(`#${toHex(r)}${toHex(g)}${toHex(b)}`)
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }  
  